import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import angle from '../assets/angle.svg'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3)};
    filter: drop-shadow(0px 8px 20px rgba(0, 0, 0, 0.12));
    padding: ${spacing(1.5, 1, 1, 1)};
    position: relative;

    &::before {
      background-color: transparent;
      background-image: url(${angle});
      background-position: 0 0;
      background-repeat: no-repeat;
      content: '';
      display: block;
      height: ${spacing(4)};
      position: absolute;
      left: ${spacing(-3.5)};
      top: ${spacing(1.5)};
      width: ${spacing(4)};
    }
  `,
  text: css`
    padding-left: ${spacing(1)};
    user-select: none;
  `,
}
